<template>
  <div style="width:100%; height:100%">
    <v-card max-width="98%" class="ma-20">
      <v-card-text>
        <v-row dense>
          <v-col cols="9" class="title blue--text"
            ><v-btn text color="primary" @click.prevent="goToCourseDetail()">{{
              isPublic(course) ? course.name  + " (Public) " : course.name
            }}</v-btn></v-col
          >
          <v-col cols="3" class=" d-none d-md-flex">
            <v-row justify="end">Published: {{ course.publishedDate }}</v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row no-gutters>
          <v-col cols="2" class="caption font-weight-light d-none d-sm-flex">
            <v-row>
              <data-overview
                :course="course"
                :showPublishDate="false"
                :showAvgInteractions="true"
              />
            </v-row>
          </v-col>
          <v-col cols="3" :class="latestActivitiesClass">
            <v-row>
              <v-col cols="12"
                ><v-row class="justify-center">Latest Activity</v-row></v-col
              >
            </v-row>
            <v-row>
              <latest-activities :course="course" />
            </v-row>
          </v-col>
          <v-col
            cols="pieChartCols"
            class="body-1 font-weight-light pie-min-width"
          >
            <v-row>
              <v-col cols="12"
                ><v-row class="justify-center">Interactions</v-row></v-col
              >
            </v-row>
            <v-row class="justify-center">
              <pie-chart
                :styles="myStyles"
                :chart-data="interactionData"
                :options="intOptions"
              />
            </v-row>
          </v-col>
          <v-col
            cols="pieChartCols"
            class="body-1 font-weight-light pie-min-width"
          >
            <v-row>
              <v-col cols="12"
                ><v-row justify="center">Time Spent</v-row></v-col
              >
            </v-row>
            <v-row justify="center">
              <pie-chart
                :styles="myStyles"
                :chart-data="timeData"
                :options="timeOptions"
              />
            </v-row>
          </v-col>
          <v-col
            cols="pieChartCols"
            class="body-1 font-weight-light pie-min-width"
            v-if="hasScore"
          >
            <v-row>
              <v-col cols="12"><v-row justify="center">Scores</v-row></v-col>
            </v-row>
            <score-pie-chart :course="course" :chartStyle="myStyles" />
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-row justify="end" class="body-2 blue--text">
              <v-btn
                text
                small
                color="primary"
                @click.prevent="goToCourseDetail()"
                >Go to Scenario</v-btn
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <log-dialog
      :headers="headers"
      :logData="logData"
      :showDialog="logDialog"
      :title="dialogTitle"
      :isLoading="loading"
      :csvFilename="csvFilename"
      :courseId="course.id"
    />
    <br />
  </div>
</template>

<script>
import PieChart from '@/components/PieChart.vue'
import DataOverview from '@/components/DataOverview.vue'
import ScorePieChart from '@/components/ScorePieChart.vue'
import LogDialog from '@/components/LogDialog.vue'
import LatestActivities from '@/components/LatestActivities.vue'
import _ from 'lodash'
import {
  timeSpentTitle,
  interactionTitle,
  interactionTableHeader,
  timeSpentTableHeader,
  getDuration,
  roundToTwo,
  pieChartStyle,
  TOTAL_ITEMS,
  sortDataByDate,
  ellipsisLongText
} from '../Constants'

export default {
  props: {
    course: Object
  },
  components: {
    PieChart,
    LatestActivities,
    DataOverview,
    LogDialog,
    ScorePieChart
  },
  data() {
    return {
      loading: false,
      headers: [],
      logData: [],
      logDialog: false,
      interactionData: {},
      intOptions: null,
      timeData: {},
      timeOptions: null,
      hasScore: false,
      dialogTitle: '',
      csvFilename: '',
      latestActivitiesClass: 'body-1 font-weight-light'
    }
  },
  created() {
    window.addEventListener('resize', this.windowResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.windowResize)
  },
  mounted() {
    this.hasScore = false
    if (this.course.scores !== undefined && this.course.scores != null) {
      this.hasScore = true
    }
    this.fillInteractionsData()
    this.fillTimeSpentData()
  },
  methods: {
    isPublic(course) {
      return course && course.courseId.includes('/public')
    },
    windowResize() {
      this.latestActivitiesClass = 'body-1 font-weight-light'
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md':
          this.latestActivitiesClass = 'd-none'
          break
        default:
          this.latestActivitiesClass = 'body-1 font-weight-light'
      }
    },
    fillTimeSpentData() {
      let timeData = new Array()
      let timeLabels = new Array()

      if (
        this.course.timeSpentCount !== undefined &&
        this.course.timeSpentCount != null
      ) {
        this.course.timeSpentCount.forEach((element) => {
          timeData.push(element.timeSpentItems.length)
          let label = element.name.replace(
            element.min,
            getDuration(element.min)
          )

          label = label.replace(element.max, getDuration(element.max))
          timeLabels.push(label)
          element.timeSpentItems.forEach(item => {
            item.count = getDuration(item.count)
          })
        })
      }

      this.timeOptions = {
        hover: {
          onHover: function(e) {
            e.target.style.cursor = 'pointer'
          }
        },
        onClick: this.onClickTime,
        legend: {
          display: false
        },
        layout: {
          padding: {
            top: 15,
            right: 5,
            left: 5
          }
        },
        tooltips: {
          position: 'nearest',
          callbacks: {
            title: function(tooltipItem, data) {
              return ellipsisLongText(
                data['labels'][tooltipItem[0]['index']],
                31
              )
            },
            label: function(tooltipItem, data) {
              const timeSpentCount =
                data['datasets'][0]['metadata'][tooltipItem['index']]
              let toolTip = new Array()
              if (timeSpentCount !== undefined && timeSpentCount != null) {
                timeSpentCount.timeSpentItems.forEach(element => {
                  if (toolTip.length < TOTAL_ITEMS) {
                    toolTip.push(
                      `${element.count} ${ellipsisLongText(element.name, 20)}`
                    )
                  }
                })

                if (timeSpentCount.timeSpentItems.length > TOTAL_ITEMS) {
                  const diff =
                    timeSpentCount.timeSpentItems.length - TOTAL_ITEMS
                  toolTip.push(`and ${diff} more`)
                }
              }
              return toolTip
            }
          },
          backgroundColor: '#FFF',
          titleFontSize: 10,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          bodyFontSize: 12,
          displayColors: false,
          borderWidth: 0.2,
          borderColor: '#000',
          yAlign: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 30,
        animation: {
          animateRotate: true,
          animateScale: true
        }
      }

      this.timeData = {
        labels: timeLabels,
        datasets: [
          {
            backgroundColor: ['#4d8399', '#89b3c7'],
            metadata: this.course.timeSpentCount,
            data: timeData
          }
        ]
      }
    },
    fillInteractionsData() {
      let intData = new Array()
      let intLabels = new Array()
      if (
        this.course.interactionCount !== undefined &&
        this.course.interactionCount != null
      ) {
        this.course.interactionCount.forEach((element) => {
          intData.push(element.interactionItems.length)
          intLabels.push(element.name)
        })
      }

      this.intOptions = {
        hover: {
          onHover: function(e) {
            e.target.style.cursor = 'pointer'
          }
        },
        onClick: this.onClickInteraction,
        legend: {
          display: false
        },
        layout: {
          padding: {
            top: 15,
            right: 5,
            left: 5
          }
        },
        tooltips: {
          position: 'nearest',
          callbacks: {
            title: function(tooltipItem, data) {
              return ellipsisLongText(
                data['labels'][tooltipItem[0]['index']],
                31
              )
            },
            label: function(tooltipItem, data) {
              const interactionCount =
                data['datasets'][0]['metadata'][tooltipItem['index']]
              let toolTip = new Array()
              if (interactionCount !== undefined && interactionCount != null) {
                interactionCount.interactionItems.forEach(element => {
                  if (toolTip.length < TOTAL_ITEMS) {
                    toolTip.push(
                      `${element.count} ${ellipsisLongText(element.name, 25)}`
                    )
                  }
                })

                if (interactionCount.interactionItems.length > TOTAL_ITEMS) {
                  const diff =
                    interactionCount.interactionItems.length - TOTAL_ITEMS
                  toolTip.push(`and ${diff} more`)
                }
              }
              return toolTip
            }
          },
          backgroundColor: '#FFF',
          titleFontSize: 10,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          bodyFontSize: 12,
          displayColors: false,
          borderWidth: 0.2,
          borderColor: '#000',
          yAlign: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 30,
        animation: {
          animateRotate: true,
          animateScale: true
        }
      }
      this.interactionData = {
        labels: intLabels,
        datasets: [
          {
            metadata: this.course.interactionCount,
            backgroundColor: ['#755b7f', '#928594'],
            data: intData
          }
        ]
      }
    },
    goToCourseDetail() {
      this.$router.push({ path: `/courses/${this.course.id}` })
    },
    onClickTime(event, array) {
      this.logData = []
      this.logDialog = true
      this.dialogTitle = timeSpentTitle
      this.headers = timeSpentTableHeader
      const courseName = this.course.name.replace(/\s+/g, '_')

      this.csvFilename = courseName + '_' + 'timeSpent_log'
      this.loading = true
      this.logDialog = true
      this.$store
        .dispatch('course/fetchCourse', this.course.id)
        .then(response => {
          if (
            response.interactions != null &&
            response.interactions !== undefined
          ) {
            this.logData = _.filter(response.interactions, function(o) {
              return o.duration !== undefined && o.duration != null
            })

            this.logData.forEach(element => {
              element.duration = getDuration(element.duration)
              //element.score = element.score.toFixed(2)
            })

            this.logData = sortDataByDate(this.logData)

            this.loading = false
          }
        })
        .catch(err => (this.loading = false))
    },
    onClickInteraction(event, array) {
      this.logData = []
      this.logDialog = true
      this.dialogTitle = interactionTitle
      this.headers = interactionTableHeader
      const courseName = this.course.name.replace(/\s+/g, '_')

      this.csvFilename = courseName + '_' + 'interactions_log'
      this.loading = true
      this.logDialog = true
      this.$store
        .dispatch('course/fetchCourse', this.course.id)
        .then(response => {
          if (
            response.interactions != null &&
            response.interactions !== undefined
          ) {
            this.logData = _.filter(response.interactions, function(o) {
              return (
                o.verb !== 'attempted' &&
                o.verb != 'failed' &&
                o.verb != 'passed'
              )
            })
            this.logData.forEach(element => {
              if (element.duration) {
                element.duration = getDuration(element.duration)
              }
              element.score = roundToTwo(element.score)
            })

            this.logData = sortDataByDate(this.logData)

            this.loading = false
          }
        })
        .catch(err => (this.loading = false))
    },
    formatDuration(date) {
      return getDuration(date)
    }
  },
  computed: {
    myStyles() {
      return pieChartStyle
    },
    pieChartCols() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return '4'
          break
        default:
          return '2'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  margin-top: 20px;
  margin-bottom: 20px;
}
.pie-min-width {
  min-width: 70px;
}
</style>
